export default __webpack_public_path__ + "static/blossomSCA-2aecd8c3695efbcc9e1fd607d87ec597.webp";